import { logger } from "@src/shared/helpers/logger";
import { get, isString } from "radashi";

export function getErrorMessage(error: unknown): string {
  if (typeof error === "string") return error;

  if (Array.isArray(error)) {
    const textErrors = error
      .map((error: unknown) => {
        const message = getErrorMessage(error);
        return isString(message) ? message : undefined;
      })
      .filter(isString);

    if (textErrors.length > 0) {
      return textErrors.join("\n");
    }
  }

  const message = get(error, "data") || get(error, "message");
  if (isString(message)) return message;

  if (Array.isArray(message)) {
    return getErrorMessage(message);
  }

  const errors = get(error, "errors");
  if (Array.isArray(errors)) {
    return getErrorMessage(errors);
  }

  logger.warn(
    "Unable to get error message for error",
    JSON.stringify(error, null, 2),
  );
  return "Unknown Error";
}
